import { useAppContext } from "../../contexts/AppContext";
import Results from "./Results";
import NoResultsBox from "./NoResultsBox";
import type { GhostAuthor, GhostPost, GhostTag } from "../../types";

const INVALID_URL_REGEX = /\/404\/$/;

export default function SearchResultBox() {
  const { searchValue = "", searchIndex, indexComplete } = useAppContext();

  let filteredPosts: GhostPost[] = [];
  let filteredAuthors: GhostAuthor[] = [];
  let filteredTags: GhostTag[] = [];

  if (indexComplete && searchValue) {
    const searchResults = searchIndex?.search(searchValue);
    filteredPosts = searchResults?.posts ?? [];
    filteredAuthors = (searchResults?.authors ?? []).filter(
      (a) => !(a?.url && INVALID_URL_REGEX.test(a.url)),
    );
    filteredTags = (searchResults?.tags ?? []).filter(
      (t) => !(t?.url && INVALID_URL_REGEX.test(t.url)),
    );
  }

  const hasResults =
    filteredPosts.length || filteredAuthors.length || filteredTags.length;

  if (hasResults) {
    return (
      <Results
        posts={filteredPosts}
        authors={filteredAuthors}
        tags={filteredTags}
      />
    );
  }
  if (searchValue) {
    return <NoResultsBox />;
  }
  return null;
}
